<template>
  <div class="SellReportPage page">
     <div class="page-title">
      <span>Revenue Report</span>
      <UiDropdownCurrency :currencyRates="getCurrencyRates" :getCurrencies="getCurrencies" @getData="selectCurrency"/>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" :disableCompareDate="false" :queryMode="this.query.mode"/>
    <div class="column-filter">
      <UiReportList :reportList="reportList" />
      <div class="column-filter-wrapper">
        <button class="btn btn-csv customize-button" @click="toggleColumnFilter()">
          {{ $t('customize') }}
        </button>
        <UiButtonCustomize :isShowColumnsSelect="isShowColumnsSelect" :fields="fields"/>
      </div>
    </div>
    <UiCheckboxRevenue @onChangeOnlyPaid="onChangeOnlyPaid" />
    <UiHighCharts :options="prepareChartOptions()" :noConvertDate="true" :loading="loading || !(reportData && reportData.items && typeof (reportData.items) === 'object')"></UiHighCharts>
    <UiTableReportCommon :report="reportData" :colsData="visibleFields"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import formatNum from 'format-num'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiHighCharts from '@/components/UiHighCharts'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiCheckboxRevenue from '@/components/UiCheckboxRevenue'
import UiReportList from '@/components/UiReportList'
import UiTableReportCommon from '@/components/UiTableReportCommon'
import UiButtonCustomize from '@/components/UiButtonCustomize'
import UiDropdownCurrency from '@/components/UiDropdownCurrency'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
import i18n from '@/i18n'
export default {
  name: 'TotalRevenuePage',
  components: {
    UiFilterbar,
    UiHighCharts,
    UiReportList,
    UiTableReportCommon,
    UiCheckboxRevenue,
    UiButtonCustomize,
    UiDropdownCurrency
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        registerIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      filterType: 'DATE',
      type: 'products',
      isShowColumnsSelect: false,
      reportList: reportListData.revenue,
      fields: [
        { key: 'totalRevenue', label: i18n.t('total_revenue'), visible: false },
        { key: 'totalTax', label: i18n.t('tax'), visible: false },
        { key: 'netRevenue', label: i18n.t('net_revenue'), visible: false },
        { key: 'avgOrderValue', label: i18n.t('avg_order_value'), visible: false },
        { key: 'orderCount', label: i18n.t('number_of_orders'), visible: false },
        { key: 'avgItemCount', label: i18n.t('avg_number_of_item_per_order'), visible: false },
        { key: 'revNewCustomer', label: i18n.t('new_customer'), visible: true },
        { key: 'revReturnCustomer', label: i18n.t('returning_customer'), visible: true },
        { key: 'totalRefund', label: i18n.t('refund'), visible: false },
        { key: 'totalDiscount', label: i18n.t('discount'), visible: false }
      ],
      filteredFields: [],
      reportData: {}
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates',
      getIsChangeStore: 'report/getIsChangeStore'
    }),
    visibleFields () {
      return this.fields.filter(field => field.visible)
    }
  },
  watch: {
    report: function (news, old) {
      if (news != null && news !== old) {
        this.reportData = news
      }
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      setCustomizeData: 'report/setCustomizeData'
    }),
    selectCurrency () {
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...this.day
        }
      }).then(() => {
        this.reportData = {}
        this.setCustomizeData(this.visibleFields)
        setTimeout(() => {
          this.reportData = this.report
        }, 100)
      })
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      }).then(() => {
        this.reportData = {}
        this.setCustomizeData(this.visibleFields)
        setTimeout(() => {
          this.reportData = this.report
        }, 100)
      })
    },
    onDefaultFilter (day, type, reportingMode, outletIds, registerIds) {
      this.day = day
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      }).then(() => {
        this.reportData = {}
        this.setCustomizeData(this.visibleFields)
        setTimeout(() => {
          this.reportData = this.report
        }, 100)
      })
    },
    toggleColumnFilter () {
      this.isShowColumnsSelect = !this.isShowColumnsSelect
    },
    documentClick (e) {
      const el = this.$refs.columnsList
      const target = e.target
      if (el && el !== target && !el.contains(target)) {
        this.isShowColumnsSelect = false
      }
    },
    formartDate (date) {
      return moment(new Date(moment(date).toDate().toUTCString())).format('MMM DD YYYY')
    },
    formatTotal (total, item = null, isNotShowCurrency = false) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      const toCurrency = currentCurrent?.toCurrency
      var rate = item && item.presentmentCurrency && item.currencyExchangeRate && (toCurrency === item.presentmentCurrency) ? item.currencyExchangeRate : (currentCurrent?.rate || '1')
      return isNotShowCurrency ? (Number(total) * Number(rate)).toFixed(2) : `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(rate)).toFixed(2), { maxFraction: 2 })}`
    },
    prepareChartOptions () {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      const productList = this.reportData && this.reportData.items ? Object.keys(this.reportData.items).map(item => item.length < 8 ? item : this.formartDate(item)) : []
      const valueList = this.reportData && this.reportData.items ? Object.keys(this.reportData.items).map(item => Number(this.formatTotal(this.reportData.items[item].revNewCustomer || 0, null, true))) : []
      const valueList2 = this.reportData && this.reportData.items ? Object.keys(this.reportData.items).map(item => Number(this.formatTotal(this.reportData.items[item].revReturnCustomer || 0, null, true))) : []
      return {
        chart: {
          type: 'column',
          redraw: true,
          panning: true,
          reflow: false,
          animation: false
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          },
          series: {
            pointPadding: 0
          }
        },
        tooltip: {
          enabled: true,
          animation: false,
          valueDecimals: 2,
          valuePrefix: currentCurrent?.symbol || storeConfig.symbol
        },
        series: [
          {
            name: i18n.t('new_customer'),
            data: valueList
          },
          {
            name: i18n.t('returning_customer'),
            data: valueList2
          }
        ],
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'category',
          categories: productList,
          min: 0,
          max: valueList?.length > 50 ? 50 : valueList?.length - 1,
          scrollbar: {
            enabled: true
          },
          tickLength: 0
        },
        colors: ['#2caffe', '#00e272'],
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            formatter: (value) => `${currentCurrent?.symbol || storeConfig.symbol}${value.value}`
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        }
      }
    },
    onChangeOnlyPaid (value) {
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          revenueType: value
        }
      }).then(() => {
        this.reportData = {}
        this.setCustomizeData(this.visibleFields)
        setTimeout(() => {
          this.reportData = this.report
        }, 100)
      })
    }
  },
  created () {
    const self = this

    window.addEventListener('click', function (e) {
    // close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.isShowColumnsSelect = false
      }
    })
  },
  destroyed () {
    // important to clean up!!
    document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style lang="scss" scoped>
  .page {
    padding: 0 30px;
  }
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter {
    display: flex;
    justify-content: space-between;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0 30px;
  }
</style>
